import React from "react";
import { Form, Button } from "antd";
import { useIntl } from "react-intl";

import PasswordFormItem from "../passwordFormItem";
import LoginFormContainer from "../loginFormContainer";

const { Item } = Form;

const ChangePasswordForm = ({ form, onSubmit, loading }) => {
  const intl = useIntl();
  return (
    <LoginFormContainer>
      <Form onSubmit={onSubmit}>
        <PasswordFormItem
          fieldName="newPassword"
          placeHolder={intl.formatMessage({
            id: "user.newPassword",
            defaultMessage: "nové heslo",
          })}
          autoComplete="new-password"
          message={intl.formatMessage({
            id: "user.emptyNewPassword",
            defaultMessage: "Vyplňte prosím heslo!",
          })}
          getFieldDecorator={form.getFieldDecorator}
        />
        <PasswordFormItem
          autoComplete="new-password"
          fieldName="confirmNewPassword"
          placeHolder={intl.formatMessage({
            id: "user.confirmNewPassword",
            defaultMessage: "potvrzení nového hesla",
          })}
          message={intl.formatMessage({
            id: "user.emptyConfirmNewPassword",
            defaultMessage: "Potvrďte prosím heslo!",
          })}
          getFieldDecorator={form.getFieldDecorator}
        />
        <Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {intl.formatMessage({
              id: "user.savePassword",
              defaultMessage: "Změnit heslo",
            })}
          </Button>
        </Item>
      </Form>
    </LoginFormContainer>
  );
};

export default Form.create()(ChangePasswordForm);
